import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { LocaleProvider } from './i18n';
import '@kia/ui/brand.css'; // shared brand primitives (also inlined into the marketing site) — first
import './styles/tokens.css';
import './styles/base.css';
import './ui/components.css';

// Global client-error capture → server error_log (NORTH_STAR §11). Best-effort, never throws.
window.addEventListener('error', (ev) => {
  try {
    const session = localStorage.getItem('ct.session');
    if (!session) return;
    const { token } = JSON.parse(session) as { token: string };
    void fetch('/api/clientlog', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify({
        where: location.pathname,
        message: `${ev.message} @${(ev.filename ?? '').split('/').pop()}:${ev.lineno ?? ''}`,
        context: {},
      }),
    }).catch(() => {});
  } catch {
    // never let the reporter itself throw
  }
});

const root = document.getElementById('root');
if (!root) throw new Error('#root element not found');

createRoot(root).render(
  <StrictMode>
    <LocaleProvider>
      <App />
    </LocaleProvider>
  </StrictMode>,
);
